import { Fragment, useState } from "react";
import { Outlet } from "react-router-dom";
import { Navigation } from "../components";
import { Scrollbars } from "rc-scrollbars";
import SignalRService from "../services/signalR.service";
import { BLOOM_ICON_ONLY } from "../utils/constants/images";
import "./master.layout.css";

function MasterLayout() {
    const [margin, setMargin] = useState(56);

    return (
        <Fragment>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flex: 1,
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                <SignalRService />
                <Navigation setMargin={setMargin} />
                <img
                    src={BLOOM_ICON_ONLY}
                    className="app-bloom-watermark"
                    alt=""
                    aria-hidden="true"
                />
                <Scrollbars
                    autoHide
                    renderThumbVertical={(props) => <div {...props} className="thumb-vertical" />}
                    style={{
                        width: "calc(100vw - 50px)",
                        height: "100vh",
                        marginLeft: margin,
                        transition: "margin-left 0.3s ease-out",
                    }}
                >
                    <div style={{ padding: 20 }} className="app-content-layer">
                        <Outlet />
                    </div>
                </Scrollbars>
            </div>
        </Fragment>
    );
}

export default MasterLayout;
